export default __webpack_public_path__ + "static/media/management.636f9c7b.svg";